import React from "react";

const Career = () => {
  return (
    <div className="w-full h-screen">
      <iframe
  src="https://zfrmz.in/0KlcvDrRNFersN7r7z1t"
  style={{ width: "100%", height: "100%", border: "none",borderRadius: "3px" }}
  id="popup-Devw2FfiztL7vtSeURQU" 
  data-layout="{'id':'POPUP'}"
  data-trigger-type="alwaysShow"
  data-trigger-value=""
  data-activation-type="alwaysActivated"
  data-activation-value=""
  data-deactivation-type="neverDeactivate"
  data-deactivation-value=""
  data-form-name="Internship Application Form"
  data-height="5374"
  data-layout-iframe-id="popup-Devw2FfiztL7vtSeURQU"
  data-form-id="Devw2FfiztL7vtSeURQU"
  title="Internship Application Form"
      >
</iframe>
<script src="https://pay.apcci.in/js/form_embed.js"></script>
    </div>
  );
};

export default Career;
